module.exports = __webpack_public_path__ + "static/media/bpjs_kesehatan.60515591.png";